import { createContext, useContext, useEffect, useState } from "react";

import { getSchool } from "../services/school-api";

// Repli neutre si l'API ne répond pas : aucun lien affiché, règles par défaut.
export const DEFAULT_SCHOOL = {
  name: "",
  contactEmail: null,
  contactUrl: null,
  privacyUrl: null,
  imageRightsUrl: null,
  faviconUrl: null,
  unitCourseTitle: null,
  unitCourseText: null,
  unitCourseUrl: null,
  majorityAge: 18,
  maxLegalTutors: 2,
  phoneCountries: ["BE", "FR", "LU"],
  defaultPhoneCountry: "BE",
  // Options de l'école utiles au formulaire ; absente = activée (comportement historique).
  options: { WAITING_LIST: true },
};

const SchoolContext = createContext(DEFAULT_SCHOOL);

export const useSchool = () => useContext(SchoolContext);

// Seuls les liens http(s) sont rendus (l'API les valide déjà ; défense en profondeur).
export const safeUrl = (url) =>
  typeof url === "string" && /^https?:\/\//.test(url) ? url : null;

const applyToDocument = (school) => {
  if (school.name) {
    document.title = `Inscription - ${school.name}`;
  }
  const favicon = safeUrl(school.faviconUrl);
  if (favicon) {
    document
      .querySelectorAll("link[rel='icon'], link[rel='apple-touch-icon']")
      .forEach((link) => link.setAttribute("href", favicon));
  }
};

export function SchoolProvider({ children }) {
  const [school, setSchool] = useState(DEFAULT_SCHOOL);

  useEffect(() => {
    getSchool()
      .then((data) => {
        const merged = {
          ...DEFAULT_SCHOOL,
          ...data,
          options: { ...DEFAULT_SCHOOL.options, ...data?.options },
        };
        setSchool(merged);
        applyToDocument(merged);
      })
      .catch(() => {
        // réglages indisponibles : le formulaire reste utilisable avec le repli neutre
      });
  }, []);

  return (
    <SchoolContext.Provider value={school}>{children}</SchoolContext.Provider>
  );
}
